export default __webpack_public_path__ + "static/media/place_du_marche.d4c4ab47.jpg";